import React, { useEffect, useState } from "react";
import * as XLSX from "xlsx";
import axios from "axios";
import Header from "./gapsy-header";
import Navigation from "./gapsy-Mnavigation";
import Footer from "./gapsy-footer";
import styles from "../assets/css/gapsy-dashboard.module.css";
import tableStyles from "../assets/css/sharedTableStyles.module.css";
import { previewrdmdata, shariahmappingdata, updatedataApi, updatetextfile3001 } from '../components/ApiProperty';
import { Modal, Button, Form } from 'react-bootstrap';
import { submitButtonStyle, cancelButtonStyle, UploadLoadingIcon } from "../components/Propertyfile";
import GapsyShariahDescription from "../components/GapsyShariahDescription";



const GapsyResidualModify = () => {
    const [sheetData, setSheetData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [indexRows, setIndexRows] = useState([]);
    const [messageType, setMessageType] = useState(''); // 'success' or 'error'
    const [modalMessage, setModalMessage] = useState('');
    const [showModal, setShowModal] = useState(false);
    const [operationalRiskCharge, setOperationalRiskCharge] = useState("");
    const [tempData, setTempData] = useState([]);
    const [liveData, setLiveData] = useState([]);
    const [makerRemarks, setMakerRemarks] = useState("");
    const [showReportingModal, setShowReportingModal] = useState(false);
    const [reportingMessage, setReportingMessage] = useState("");
    const [allowSubmit, setAllowSubmit] = useState(true);
    const [isViewMode, setIsViewMode] = useState(false);
    const [showConfirmApprove, setShowConfirmApprove] = useState(false);
    const [rejectedReason1, setRejectedReason1] = useState("");
    const [inputValue, setInputValue] = useState("");
    const [showmakerRemarks, SetshowMakerremarks] = useState(false);
    const [reportingDate, setReportingDate] = useState("");
    const [isEditMode, setIsEditMode] = useState(false);
    const [q1, setQ1] = useState("");
    const [q2, setQ2] = useState("");
    const [q3, setQ3] = useState("");
    let csrfToken = sessionStorage.getItem("tokenizedSession");
    const userId = localStorage.getItem("userid");
    const department = sessionStorage.getItem("dept");
    const [initialIndexRows, setInitialIndexRows] = useState([]);
    const [initialGradeRows, setInitialGradeRows] = useState([]);
    const [gradeRows, setGradeRows] = useState([]);
    const [excelLoaded, setExcelLoaded] = useState(false);


    useEffect(() => { loadExcel(); }, []);

    const fmt = (val) => {
        if (val === null || val === undefined || val === "") return "-";
        if (typeof val === "number") {
            if (val > 0 && val < 1) return (val * 100).toFixed(0) + "%";
            return val.toLocaleString("en-US", { maximumFractionDigits: 2 });
        }
        return String(val);
    };

    useEffect(() => {
        fetchPreviewData();
    }, []);

    const loadReportingDateData = async (quarter) => {

        if (!quarter) {
            handleReset();
            setIsEditMode(true);
            setMakerRemarks("");
            setRejectedReason1("");
            setIsViewMode(false);
            return;
        }

        const reportDate = getReportingDate(quarter);

        // Get mapping API data
        const mappingData = (await loadShariahMapping(reportDate)) || [];

        const hasMapping = mappingData.length > 0;

        if (!hasMapping) {
            restoreExcelValues();
        }

        // Get temp records
        const records = tempData.filter(
            row =>
                row.reporting_date === reportDate &&
                !isNullValue(row.Rejected_Reason)
        );

        // Clear previous values
        handleReset();

        if (records.length === 0) {
            handleReset();
            setMakerRemarks("");
            setRejectedReason1("");
            setIsViewMode(false);
            return;
        }

        // Quarter values (first row contains these)
        const first = records[0];

        setQ1(first.quarter1 === "\\N" ? "" : first.quarter1);
        setQ2(first.quarter2 === "\\N" ? "" : first.quarter2);
        setQ3(first.quarter3 === "\\N" ? "" : first.quarter3);

        const rejectedReason1 = records.find(
            r => !isNullValue(r.Rejected_Reason)
        )?.Rejected_Reason || "";

        setRejectedReason1(rejectedReason1);

        if (records.length === 0) {
            handleReset();
            setIsViewMode(false);
            return;
        }
        // Operational Risk Charge
        const chargeRow = records.find(r =>
            (r.particulars || "").includes("Operational Risk")
        );

        if (chargeRow) {
            setOperationalRiskCharge(
                chargeRow.amount === "\\N" ? "" : chargeRow.amount
            );
        }

        // -----------------------------
        // Update Index Rows
        // -----------------------------
        const updatedRows = initialIndexRows.map(row => {

            const mapRow = hasMapping
                ? mappingData.find(
                    m => (m.key_area || "").trim() === row.keyArea.trim()
                )
                : null;

            const dbRow = records.find(
                r => (r.key_areas || "").trim() === row.keyArea.trim()
            );

            return {
                ...row,

                // From Mapping API
                weight: mapRow
                    ? Number(mapRow.weight) / 100
                    : row.weight,

                weightDisplay: mapRow?.weight,

                // From Temp Table
                observations:
                    dbRow?.no_of_observations_issues_non_compliance_delays_self_assesment_b === "\\N"
                        ? ""
                        : dbRow?.no_of_observations_issues_non_compliance_delays_self_assesment_b || "",

                impact:
                    dbRow?.impact_scale_of_1_to_10_c === "\\N"
                        ? ""
                        : dbRow?.impact_scale_of_1_to_10_c || "",

                index:
                    dbRow?.index_a_b_c === "\\N"
                        ? 0
                        : Number(dbRow?.index_a_b_c || 0)
            };
        });

        setIndexRows(updatedRows);

        // -----------------------------
        // Update Grade Rows
        // -----------------------------

        console.log("Excel Grade Rows:", initialGradeRows);
        console.log("Mapping Data:", mappingData);

        const gradeMapping = mappingData.filter(item => item.score_grade);

        const updatedGradeRows = initialGradeRows.map((row, index) => {
            const match = gradeMapping[index];

            if (!match) return row;

            return {
                ...row,
                scoreGrade: match.score_grade,
                min: Number(match.min),
                max: Number(match.max),
                percentage: Number(match.percentage) / 100,
            };
        });

        setGradeRows(updatedGradeRows);

        // Read only mode
        setIsViewMode(true);
    };

    useEffect(() => {

        if (excelLoaded && reportingDate) {
            loadReportingDateData(reportingDate);
        }

    }, [excelLoaded, reportingDate]);

    const fetchTableData = async (tableName) => {

        const config = {
            headers: {
                userId: localStorage.getItem("userid"),
                "x-csrf-token": csrfToken,
            },
            withCredentials: true,
            params: {
                tableName,
                dataModel: "DEM",
            },
        };

        // Get JSON filename
        const apiResponse = await axios.post(previewrdmdata, {}, config);

        if (!apiResponse.data?.fileName) {
            throw new Error(`No data file available for ${tableName}`);
        }

        const fetchedFileName = apiResponse.data.fileName;

        // Fetch JSON
        const dataResponse = await fetch(`/jsonfiles/${fetchedFileName}`);

        if (!dataResponse.ok) {
            throw new Error(`Failed to load ${fetchedFileName}`);
        }

        const jsonData = await dataResponse.json();

        return {
            fileName: fetchedFileName,
            data: jsonData
        };
    };

    const fetchPreviewData = async () => {
        try {

            const [tempResult, liveResult] = await Promise.all([
                fetchTableData("Risk_residual_credit_risk_temp"),
                fetchTableData("Risk_residual_credit_risk_live")
            ]);

            const tempRows = tempResult.data || [];

            setTempData(tempRows);
            setLiveData(liveResult.data || []);
            await loadExcel(tempRows);
            const storedDate = localStorage.getItem("selectedReportingDate");

            if (storedDate) {

                const quarter = reportingDates.find(
                    item => getReportingDate(item) === storedDate
                );

                if (quarter) {
                    setReportingDate(quarter);   // Same as selecting from dropdown
                    // setShowDownload(false);
                    setAllowSubmit(false);
                }

                localStorage.removeItem("selectedReportingDate");
            }

        } catch (err) {
            console.error("Preview Fetch Error:", err);
        }
    };

    const str = (c) => (c == null ? "" : String(c).trim());

    const isNullValue = (value) => {
        if (value == null) return true;

        const v = String(value).trim().toUpperCase();

        return (
            v === "" ||
            v === "\\N" ||
            v === "N" ||
            v === "//N" ||
            v === "NULL"
        );
    };
   
    const loadShariahMapping = async (reportDate) => {
        try {

            const config = {
                headers: {
                    userId: localStorage.getItem("userid"),
                    "x-csrf-token": csrfToken,
                },
                withCredentials: true,
                params: {
                    userId: localStorage.getItem("userid"),
                    dept: department,
                    tableName: "Shariah",
                    reportingDate: reportDate
                }
            };

            const response = await axios.post(
                shariahmappingdata,
                {},
                config
            );

            return response.data.data || [];

        } catch (err) {
            console.error(err);
            return [];
        }
    };

    const reportingDates = [
        "Q2-2025",
        "Q3-2025",
        "Q4-2025",
        "Q1-2026",
        "Q2-2026",
        "Q3-2026",
        "Q4-2026"
    ];

    const handleCancel = () => {
        restoreExcelValues();
        if (messageType === "success") {
            // setReportingDate("");
            // handleReset();
            setIsEditMode(false);
            setMakerRemarks("");
            setIsViewMode(true);
        }

        setShowModal(false);
        setModalMessage("");
    };

    const loadExcel = async (tempRows = []) => {
        try {
            const response = await fetch("/templates/sharaiah_template_sheet.xlsx");
            if (!response.ok) throw new Error("Unable to load Excel file.");

            const data = await response.arrayBuffer();
            // const workbook = XLSX.read(data, { type: "array" });
            const workbook = XLSX.read(data, {
                type: "array",
                cellText: true
            });
            const sheetName = "Shariah Risk (P 2) - Dec 25";
            const worksheet = workbook.Sheets[sheetName];
            if (!worksheet) { alert(`${sheetName} sheet not found`); return; }

            const rows = XLSX.utils.sheet_to_json(worksheet, {
                header: 1,
                defval: null,
                raw: true
            });

            // ── Helper: find the first row index where col1 matches a predicate ──
            const findRow = (predicate, from = 0) => {
                for (let i = from; i < rows.length; i++) {
                    const row = rows[i] || [];
                    if (predicate(row, i)) return i;
                }
                return -1;
            };

            const c1 = (row) => str(row[1]);

            // ── Locate landmark rows by content ──
            const iRow = findRow(r => r[0] === 1 && c1(r).toLowerCase().includes("name of risk"));
            const iSec2 = findRow(r => r[0] === 2);
            const iDefLabel = findRow(r => c1(r).toLowerCase().startsWith("definition"));
            const iSec3 = findRow(r => r[0] === 3 && c1(r).toLowerCase().includes("key areas"));
            const iSec4 = findRow(r => r[0] === 4 && c1(r).toLowerCase().includes("risk measurement"));
            const iIntro = findRow(r => c1(r).toLowerCase().includes("keeping in view"), iSec4);
            const iTableTitle = findRow(r => c1(r).toLowerCase().includes("computation of shariah"), iSec4);
            const iPeriod = findRow(r => c1(r).toLowerCase().startsWith("period"), iSec4);
            const iIdxHdr = findRow(r => c1(r).toLowerCase() === "key areas" && r[0] === null, iTableTitle);
            // const iTotalRow = findRow(r => (r[1] === null || r[1] === undefined || str(r[1]) === "") && typeof r[2] === "number", iIdxHdr + 1);
            const iTotalRow = findRow(
                r => {
                    const label = str(r[1]).toLowerCase();

                    return (
                        label.includes("total") ||
                        (label === "" && typeof r[2] === "number")
                    );
                },
                iIdxHdr + 1
            );
            const iGradeHdr = findRow(r => c1(r).toLowerCase() === "score grade", iTotalRow);
            const iPartHdr = findRow(r => c1(r).toLowerCase() === "particulars", iGradeHdr);
            const iQuarterHdr = findRow(r => [r[1], r[2], r[3], r[4]].some(c => /^Q\d-\d{4}$/i.test(str(c))), iPartHdr);
            const iQuarterVal = findRow(r => [r[1], r[2], r[3], r[4]].every(c => typeof c === "number"), iQuarterHdr + 1);
            const iFinalCap = findRow(r => c1(r).toLowerCase().includes("final capital charge"), iQuarterVal);

            // ── Extract each section ──

            // 1. Name of risk
            const rowNameOfRisk = rows[iRow] || [];
            const nameOfRisk = str(rowNameOfRisk[3]) || str(rowNameOfRisk[2]) || "";

            // 2. Summary
            const summary = iSec2 >= 0 ? c1(rows[iSec2]) : "";

            // 3. Definition
            const definition = iDefLabel >= 0 ? c1(rows[iDefLabel]) : "";
            const defTextRow = iDefLabel >= 0 ? findRow(r => c1(r).length > 10, iDefLabel + 1) : -1;
            const definitionText = defTextRow >= 0 ? c1(rows[defTextRow]) : "";

            // 4. Pillar
            const iPillar = findRow(r => c1(r).toUpperCase().includes("PILLAR"));
            const pillar = iPillar >= 0 ? c1(rows[iPillar]) : "";

            // 5. Key areas
            const keyAreasIntroRow = findRow(r => c1(r).toLowerCase().includes("the bank considers"), iSec3);
            const keyAreasIntro = keyAreasIntroRow >= 0 ? c1(rows[keyAreasIntroRow]) : "";
            const keyAreas = [];
            const keyEnd = iSec4 >= 0 ? iSec4 : rows.length;
            for (let i = (keyAreasIntroRow >= 0 ? keyAreasIntroRow + 1 : iSec3 + 1); i < keyEnd; i++) {
                const txt = c1(rows[i]);
                if (txt.length > 10) keyAreas.push(txt);
            }

            // 6. Risk measurement
            const heading = iSec4 >= 0 ? c1(rows[iSec4]) : "";
            const intro = iIntro >= 0 ? c1(rows[iIntro]) : "";
            const tableTitle = iTableTitle >= 0 ? c1(rows[iTableTitle]) : "";
            const period = iPeriod >= 0 ? c1(rows[iPeriod]) : "";

            // Index table headers (cols 1,2,3,5,7 — skip merged empty cols)
            const indexHeaders = iIdxHdr >= 0
                ? [rows[iIdxHdr][1], rows[iIdxHdr][2], rows[iIdxHdr][3], rows[iIdxHdr][5], rows[iIdxHdr][7]]
                    .map(h => str(h).replace(/\n/g, " "))
                : [];

            // setIndexRows(indexRows);
            const parsedIndexRows = [];

            if (iIdxHdr >= 0 && iTotalRow >= 0) {
                for (let i = iIdxHdr + 1; i < iTotalRow; i++) {

                    const r = rows[i];

                    if (c1(r).length > 0) {

                        const keyArea = str(r[1]);

                        const tempRow = tempRows.find(
                            item =>
                                str(item.key_areas).trim().toLowerCase() ===
                                keyArea.trim().toLowerCase()
                        );

                        parsedIndexRows.push({
                            keyArea: tempRow?.key_areas || keyArea,

                            weight: tempRow?.weight_a || "0%",

                            observations:
                                tempRow?.no_of_observations_issues_non_compliance_delays_self_assesment_b === "\\N"
                                    ? 0
                                    : tempRow?.no_of_observations_issues_non_compliance_delays_self_assesment_b || 0,

                            impact:
                                tempRow?.impact_scale_of_1_to_10_c === "\\N"
                                    ? ""
                                    : tempRow?.impact_scale_of_1_to_10_c || "",

                            index: tempRow?.index_a_b_c
                                ? Number(tempRow.index_a_b_c)
                                : 0
                        });
                    }
                }
            }

            setIndexRows(parsedIndexRows);
            setInitialIndexRows(parsedIndexRows.map(row => ({ ...row })));
            // Index table data rows (between header and total row)
            const indexRows = [];
            if (iIdxHdr >= 0 && iTotalRow >= 0) {
                for (let i = iIdxHdr + 1; i < iTotalRow; i++) {
                    const r = rows[i];
                    if (c1(r).length > 0) {
                        // indexRows.push([str(r[1]), r[2], r[3], r[5], r[7]]);
                        indexRows.push({
                            keyArea: str(r[1]),
                            weight: Number(r[2]) || 0,   // A
                            observations: "",            // B (editable)
                            impact: "",                  // C (editable)
                            index: 0                     // A * B * C
                        });
                    }
                }
            }

            // Index total row
            const indexTotal = iTotalRow >= 0
                ? { weight: rows[iTotalRow][2], index: rows[iTotalRow][7] }
                : null;

            // Grade table headers (cols 1,2,3,4,6 — skip merged col 5)
            const gradeHeaders = iGradeHdr >= 0
                ? [rows[iGradeHdr][1], rows[iGradeHdr][2], rows[iGradeHdr][3], rows[iGradeHdr][4], rows[iGradeHdr][6]]
                    .map(h => str(h))
                : [];

            // Grade rows (between grade header and particulars header)
            const parsedGradeRows = [];

            const uniqueGrades = [
                ...new Map(
                    tempRows
                        .filter(row =>
                            row.score_grade &&
                            row.score_grade !== "\\N"
                        )
                        .map(row => [
                            row.score_grade,
                            row
                        ])
                ).values()
            ];

            uniqueGrades.forEach(tempRow => {

                parsedGradeRows.push({
                    scoreGrade: tempRow.score_grade,

                    min:
                        tempRow.min === "\\N"
                            ? 0
                            : Number(tempRow.min) || 0,

                    max:
                        tempRow.max === "\\N"
                            ? 0
                            : Number(tempRow.max) || 0,

                    percentage:
                        tempRow.percentage_of_operational_risk_pillar_i_capital_charge === "\\N"
                            ? "0%"
                            : tempRow.percentage_of_operational_risk_pillar_i_capital_charge || "0%",

                    applicablePercentage:
                        tempRow.applicable_percentage === "\\N"
                            ? "0%"
                            : tempRow.applicable_percentage || "0%"
                });
            });

            setGradeRows(parsedGradeRows);

            setInitialGradeRows(
                parsedGradeRows.map(row => ({ ...row }))
            );

            // Particulars rows (between particulars header and quarter header)
            const particularsRows = [];
            if (iPartHdr >= 0 && iQuarterHdr >= 0) {
                for (let i = iPartHdr + 1; i < iQuarterHdr; i++) {
                    const r = rows[i];
                    if (c1(r).length > 0) {
                        particularsRows.push({ label: c1(r), amount: r[3] });
                    }
                }
            }

            // Quarter headers and values
            const quarterHeaders = iQuarterHdr >= 0
                ? [rows[iQuarterHdr][1], rows[iQuarterHdr][2], rows[iQuarterHdr][3], rows[iQuarterHdr][4]].map(str)
                : [];
            const quarterValues = iQuarterVal >= 0
                ? [rows[iQuarterVal][1], rows[iQuarterVal][2], rows[iQuarterVal][3], rows[iQuarterVal][4]]
                : [];

            // Final capital charge
            const finalCapital = iFinalCap >= 0
                ? { label: c1(rows[iFinalCap]), val: rows[iFinalCap][5] }
                : null;

            setSheetData({
                pillar,
                nameOfRisk,
                summary,
                definition,
                definitionText,
                keyAreasIntro,
                keyAreas,
                riskMeasurement: {
                    heading,
                    intro,
                    tableTitle,
                    period,
                    indexHeaders,
                    indexRows: parsedIndexRows,
                    indexTotal,
                    gradeHeaders,
                    gradeRows: parsedGradeRows,
                    particularsRows,
                    quarterHeaders,
                    quarterValues,
                    finalCapital
                },
            });

            setExcelLoaded(true);

        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
            setExcelLoaded(true);
        }
    };

    const restoreExcelValues = () => {
        setIndexRows(initialIndexRows.map(row => ({ ...row })));
        setGradeRows(initialGradeRows.map(row => ({ ...row })));
    };

    const handleIndexChange = (rowIndex, field, value) => {
        const updatedRows = [...indexRows];

        if (field === "impact") {
            // Allow empty while editing
            if (value === "") {
                updatedRows[rowIndex].impact = "";
            } else {
                // Only allow whole numbers
                if (!/^\d+$/.test(value)) return;

                const num = Number(value);

                // Allow only 1-10
                if (num < 1 || num > 10) return;

                updatedRows[rowIndex].impact = num;
            }
        } else {
            updatedRows[rowIndex][field] = value;
        }

        const weight =
            parseFloat(String(updatedRows[rowIndex].weight || "0").replace("%", "")) / 100;

        const observations =
            Number(updatedRows[rowIndex].observations) || 0;

        const impact =
            Number(updatedRows[rowIndex].impact) || 0;

        updatedRows[rowIndex].index =
            weight * observations * impact;

        setIndexRows(updatedRows);
    };

    const totalWeight = indexRows.reduce(
        (sum, row) =>
            sum +
            (parseFloat(String(row.weight || "0").replace("%", "")) / 100),
        0
    );

    const totalIndex = indexRows.reduce(
        (sum, row) => sum + (Number(row.index) || 0),
        0
    );

    const calculatedGradeRows = gradeRows
        .filter(row =>
            row.scoreGrade &&
            row.scoreGrade !== "\\N"
        )
        .map((row) => ({
            ...row,

            applicablePercentage:
                totalIndex >= Number(row.min) &&
                    totalIndex <= Number(row.max)
                    ? row.percentage
                    : "0.00%"
        }));

    const totalApplicablePercentage = calculatedGradeRows.reduce(
        (sum, row) => {
            const percentage =
                parseFloat(
                    String(row.applicablePercentage || "0").replace("%", "")
                ) / 100;

            return sum + percentage;
        },
        0
    );

    const capitalChargeForShariahRisk = Math.round(
        (Number(operationalRiskCharge) || 0) * totalApplicablePercentage
    );

    const getQuarterSequence = (selectedQuarter) => {
        if (!selectedQuarter) return [];

        const [q, yearStr] = selectedQuarter.split("-");
        const year = Number(yearStr);
        const quarter = Number(q.replace("Q", ""));

        const quarters = [];

        for (let i = 3; i >= 0; i--) {
            let currentQuarter = quarter - i;
            let currentYear = year;

            while (currentQuarter <= 0) {
                currentQuarter += 4;
                currentYear--;
            }

            quarters.push(`Q${currentQuarter}-${currentYear}`);
        }

        return quarters;
    };

    const displayedQuarterHeaders = getQuarterSequence(reportingDate);

    const getQuarterFromDate = (date) => {
        const d = new Date(date);

        const year = d.getFullYear();
        const month = d.getMonth() + 1;

        if (month <= 3) return `Q1-${year}`;
        if (month <= 6) return `Q2-${year}`;
        if (month <= 9) return `Q3-${year}`;
        return `Q4-${year}`;
    };

    const dataMap = {};

    liveData.forEach(item => {
        const quarter = getQuarterFromDate(item.reporting_date);

        dataMap[`${item.key_areas}_${quarter}`] = item;
    });

    const getQuarterValues = (selectedQuarter, keyArea) => {

        const quarters = getQuarterSequence(selectedQuarter);

        return quarters.map(q => {

            const record = dataMap[`${keyArea}_${q}`];

            return record
                ? record.final_capital_charge_for_quarter4_average_of_4_quarters
                : "";
        });

    };

    const values = getQuarterValues(reportingDate, "Shariah Committee Matters");

    const q4 = capitalChargeForShariahRisk;

    const finalCapitalCharge = Math.round(
        (
            (Number(values[0]) || 0) +
            (Number(values[1]) || 0) +
            (Number(values[2]) || 0) +
            (Number(q4) || 0)
        ) / 4
    );

    const isSubmitEnabled =
        // allowSubmit &&
        reportingDate !== "" &&
        operationalRiskCharge !== "" &&
        indexRows.every(
            row =>
                row.observations !== "" &&
                row.impact !== ""
        );

    const formatPercentTwoDecimal = (value) => {
        if (value === "" || value == null) return "0.00%";

        return `${(Number(value) * 100).toFixed(2)}%`;
    };

    const formatPercent = (value) => {
        if (value === "" || value == null) return "0.00%";

        return `${(Number(value) * 100).toFixed(0)}%`;
    };

    const formatExcelPercent = (value) => {
        if (value === "" || value == null || value === "\\N") {
            return "0%";
        }

        // DB value already contains %
        if (String(value).includes("%")) {
            return String(value);
        }

        // Excel decimal value
        const number = Number(value);

        if (isNaN(number)) {
            return "0%";
        }

        return `${(number * 100).toFixed(0)}%`;
    };

    const formatApplicablePercent = (value) => {
        if (value === "" || value == null || value === "\\N") {
            return "0.00%";
        }

        // DB already returns percentage format like "0.00%"
        if (String(value).includes("%")) {
            return String(value);
        }

        // For decimal values like 0.03 -> 3.00%
        const number = Number(value);

        if (isNaN(number)) {
            return "0.00%";
        }

        return `${(number * 100).toFixed(2)}%`;
    };

    const formatIndex = (value) => {
        if (value === "" || value == null) return "";

        return Number(value).toLocaleString("en-US", {
            minimumFractionDigits: 1,
            maximumFractionDigits: 2,
        });
    };

    const handleReset = () => {

        setOperationalRiskCharge("");
        setQ1("");
        setQ2("");
        setQ3("");

        const resetRows = indexRows.map(row => ({
            ...row,
            observations: "",
            impact: "",
            index: 0
        }));

        setIndexRows(resetRows);
    };

    const getReportingDate = (quarter) => {
        if (!quarter) return "";

        const [q, year] = quarter.split("-");

        switch (q) {
            case "Q1":
                return `${year}-03-31`;
            case "Q2":
                return `${year}-06-30`;
            case "Q3":
                return `${year}-09-30`;
            case "Q4":
                return `${year}-12-31`;
            default:
                return "";
        }
    };

    const HandleFinalSubmit = async () => {

        if (!inputValue.trim()) {
            setMessageType("error");
            setModalMessage("Please enter Maker Remarks.");
            setShowModal(true);
            return;
        }

        try {

            setLoading(true);

            const reportDate = getReportingDate(reportingDate);

            const selectedRecords = tempData.filter(
                row => row.reporting_date === reportDate
            );

            if (selectedRecords.length === 0) {
                setMessageType("warning");
                setModalMessage("No records found.");
                setShowModal(true);
                return;
            }

            const tableNameWithJson = "residual_credit_risk.json";

            for (const record of selectedRecords) {

                const rowId = record.rowId;

                // Find the edited row from UI
                const editedRow = indexRows.find(
                    x => x.keyArea === record.key_areas
                );

                // Create latest JSON
                const {
                    created_by,
                    created_dt,
                    modified_by,
                    modified_dt,
                    ...jsonData
                } = record;

                if (editedRow) {

                    jsonData.no_of_observations_issues_non_compliance_delays_self_assesment_b =
                        editedRow.observations;

                    jsonData.impact_scale_of_1_to_10_c =
                        editedRow.impact;

                    // A × B × C
                    jsonData.index_a_b_c =
                        Number(editedRow.index || 0).toFixed(2);

                    jsonData.weight_a =
                        editedRow.weight || "0%";

                    // Applicable Percentage is based on TOTAL INDEX
                    const applicableGrade = gradeRows.find(row => {
                        const min = Number(row.min);
                        const max = Number(row.max);

                        return (
                            totalIndex >= min &&
                            totalIndex <= max
                        );
                    });

                    jsonData.applicable_percentage =
                        applicableGrade?.percentage || "0.00%";
                }

                // Quarter values from UI
                jsonData.quarter1 = q1;
                jsonData.quarter2 = q2;
                jsonData.quarter3 = q3;
                jsonData.quarter4 = q4;

                jsonData.final_capital_charge_for_quarter4_average_of_4_quarters =
                    finalCapitalCharge;

                jsonData.Maker_Remarks = inputValue;

                const content = JSON.stringify([jsonData], null, 2);

                // Step 1 - Write JSON file
                await axios.post(
                    updatetextfile3001,
                    {
                        tableNameWithJson,
                        content
                    },
                    {
                        headers: {
                            userId: localStorage.getItem("userid"),
                            "x-csrf-token": csrfToken
                        },
                        withCredentials: true
                    }
                );

                // Step 2 - Update database
                const response = await axios.post(
                    updatedataApi,
                    {},
                    {
                        headers: {
                            userId: localStorage.getItem("userid"),
                            "x-csrf-token": csrfToken
                        },
                        withCredentials: true,
                        params: {
                            filepath: `/saswork/nas/${tableNameWithJson}`,
                            Notifications: "IN",
                            dataModel: "BDM",
                            rowId: rowId,
                            tableName: "residual_credit_risk",
                            dept: department,
                            "makerRemarks": inputValue,
                        }
                    }
                );

                console.log(`Row ${rowId}`, response.data);

                if (
                    response.data?.active_status &&
                    response.data?.template_type
                ) {
                    localStorage.setItem("active_status", response.data.active_status);
                    localStorage.setItem("template_type", response.data.template_type);
                    localStorage.setItem("stage", response.data.stage);
                }
            }

            // Create status JSON only once after all rows are updated successfully
            // Create/Update status JSON
            const userId = localStorage.getItem("userid");
            const statusJsonFile = `10192_submit.json`;

            let existingData = [];

            try {
                const response = await fetch(`/jsonfiles/${statusJsonFile}`);

                if (response.ok) {
                    existingData = await response.json();
                }
            } catch (err) {
                console.log("Status file doesn't exist. Creating new file.");
            }

            const newStatus = {
                reporting_date: reportDate,
                submitted_date: new Date().toISOString().split("T")[0],
                status: "Pending for Checker Review",
                reported_by: "10192",
                reviewed_by: "10007",
                tableName: "residual_credit_risk"
            };

            // Check if same reporting date already exists
            // Remove only the same reporting_date
            existingData = existingData.filter(
                item => item.reporting_date !== newStatus.reporting_date
            );

            // Insert latest record at the beginning
            existingData.unshift(newStatus);

            const statusContent = JSON.stringify(existingData, null, 2);

            await axios.post(
                updatetextfile3001,
                {
                    tableNameWithJson: statusJsonFile,
                    content: statusContent
                },
                {
                    headers: {
                        userId,
                        "x-csrf-token": csrfToken
                    },
                    withCredentials: true
                }
            );

            setMessageType("success");
            setModalMessage("Data Modified Successfully");
            setShowModal(true);

            setReportingDate("");
            setRejectedReason1("");
            setMakerRemarks("");
            setInputValue("");

            handleReset();

            fetchPreviewData();

            SetshowMakerremarks(false);

        } catch (error) {

            console.error(error);

            setMessageType("error");
            setModalMessage(
                error.response?.data?.message ||
                error.message ||
                "Error while submitting."
            );
            setShowModal(true);

        } finally {
            setLoading(false);
        }
    };

    const handleCloseMakerPOP = () => {
        SetshowMakerremarks(false);
    };

    const getFinalCapitalLabel = (selectedQuarter) => {
        if (!selectedQuarter)
            return "Final Capital Charge (Average of 4 Quarters)";

        const [q, year] = selectedQuarter.split("-");

        const quarterEndDates = {
            Q1: `31-MAR-${year}`,
            Q2: `30-JUN-${year}`,
            Q3: `30-SEP-${year}`,
            Q4: `31-DEC-${year}`
        };

        return `Final Capital Charge for ${quarterEndDates[q]} (Average of 4 Quarters)`;
    };


    return (
        <div
            className={`d-flex flex-column min-vh-100 ${styles.pageFullBackground}`}
            style={{
                backgroundImage: "none",
                backgroundColor: "#ffffff"
            }}
        >
            <Header />
            <Navigation />
            <main className="flex-grow-1 container-fluid" style={{ margin: 0, padding: 0, background: "none" }}>
                <div className={styles.mainContainer}>
                    <div className="container-fluid py-2">
                        <div className="row">
                            <div className="row">

                                {loading && (
                                    <div className="loading-overlay">
                                        <UploadLoadingIcon />
                                    </div>
                                )}

                                {!sheetData ? (
                                    <div className="card">
                                        <div className="card-body text-center">
                                            No Data Found
                                        </div>
                                    </div>
                                ) : (
                                    <>
                                        <div className="card-header bg-primary text-white">
                                            <h5 className="mb-0">
                                                {sheetData.nameOfRisk}
                                            </h5>
                                        </div>

                                        <div className="row g-2">

                                            {/* ── LEFT col: points 1–4 ── */}
                                            <div className="col-lg-4 col-md-12">
                                                <div className={`card h-100 ${styles.cardBorder} ${styles.card}`}>
                                                    <div className="card-body">
                                                        <div className={`tableWrapper ${tableStyles.tableWrapper}`} style={{ maxHeight: "340px" }}>
                                                            <div className="">
                                                                <GapsyShariahDescription />
                                                            </div>
                                                        </div>

                                                    </div>
                                                </div>
                                            </div>
                                            {/* ── RIGHT col: tables ── */}
                                            <div className="col-lg-8 col-md-12">
                                                <div className="card h-100 shadow-sm">
                                                    {/* <div className={`tableWrapperLarge ${tableStyles.tableWrapperLarge}`}> */}
                                                    <div className="card-body">
                                                        <div className={`tableWrapper ${tableStyles.tableWrapper}`} style={{ maxHeight: "340px" }}>
                                                            <div className="table-on-homepage-only">
                                                                <div className="p-3">

                                                                    {sheetData.riskMeasurement.tableTitle && (
                                                                        <div className="px-2 pt-2 mb-3">
                                                                            <div className="d-flex justify-content-between align-items-center flex-wrap gap-2">
                                                                                <h6 className="fw-bold text-primary mb-0">
                                                                                    {sheetData.riskMeasurement.tableTitle}
                                                                                </h6>

                                                                                <div className="d-flex align-items-center gap-3 flex-wrap">

                                                                                    <label
                                                                                        htmlFor="reportingDate"
                                                                                        className="fw-semibold mb-0 text-nowrap"
                                                                                    >
                                                                                        Reporting Date
                                                                                    </label>


                                                                                    <input
                                                                                        id="reportingDate"
                                                                                        type="text"
                                                                                        className="form-control form-control-sm"
                                                                                        style={{ width: "150px" }}
                                                                                        value={reportingDate}
                                                                                        readOnly
                                                                                    />
                                                                                    {!isNullValue(rejectedReason1) && (
                                                                                        <>
                                                                                            <label className="fw-semibold mb-0 text-nowrap">
                                                                                                Rejected Reason
                                                                                            </label>

                                                                                            <span
                                                                                                className="text-danger fw-semibold"
                                                                                                style={{ maxWidth: "350px", wordBreak: "break-word" }}
                                                                                            >
                                                                                                {rejectedReason1}
                                                                                            </span>
                                                                                        </>
                                                                                    )}

                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    )}

                                                                    {/* Table 1: Shariah Risk Index */}
                                                                    {sheetData.riskMeasurement.indexHeaders.length > 0 && (

                                                                        // <div className={`tableWrapper ${tableStyles.tableWrapper}`}>
                                                                        <table className={`table table-bordered table-hover text-center customScrollTable ${tableStyles.customScrollTable}`}>
                                                                            <thead className="thead-light">
                                                                                <tr>
                                                                                    {sheetData.riskMeasurement.indexHeaders.map((h, i) => (
                                                                                        <th
                                                                                            key={i}
                                                                                            style={{
                                                                                                whiteSpace: "normal",
                                                                                                lineHeight: "1.2",
                                                                                                verticalAlign: "middle",
                                                                                                textAlign: "center"
                                                                                            }}
                                                                                        >
                                                                                            {i === 2 ? (
                                                                                                <>
                                                                                                    No. of.
                                                                                                    <br />
                                                                                                    Observations (B)
                                                                                                </>
                                                                                            ) : i === 3 ? (
                                                                                                <>
                                                                                                    Impact
                                                                                                    <br />
                                                                                                    (Scale of 1 to 10) (C)
                                                                                                </>
                                                                                            ) : (
                                                                                                h
                                                                                            )}
                                                                                        </th>
                                                                                    ))}
                                                                                </tr>
                                                                            </thead>
                                                                            <tbody>
                                                                                {indexRows.map((row, ri) => (
                                                                                    <tr key={ri}>
                                                                                        <td>{row.keyArea}</td>

                                                                                        <td>{fmt(row.weight)}</td>

                                                                                        <td>
                                                                                            <input
                                                                                                type="number"
                                                                                                min="0"
                                                                                                className="form-control form-control-sm text-end"
                                                                                                value={row.observations === "" || row.observations == null ? 0 : row.observations}
                                                                                                onChange={(e) =>
                                                                                                    handleIndexChange(ri, "observations", e.target.value)
                                                                                                }
                                                                                            />
                                                                                        </td>


                                                                                        <td>
                                                                                            <input
                                                                                                type="number"
                                                                                                min="1"
                                                                                                max="10"
                                                                                                step="1"
                                                                                                inputMode="numeric"
                                                                                                className="form-control form-control-sm text-end"
                                                                                                value={row.impact}
                                                                                                onKeyDown={(e) => {
                                                                                                    // Prevent scientific notation, +, -, decimal
                                                                                                    if (["e", "E", "+", "-", "."].includes(e.key)) {
                                                                                                        e.preventDefault();
                                                                                                    }
                                                                                                }}
                                                                                                onChange={(e) =>
                                                                                                    handleIndexChange(ri, "impact", e.target.value)
                                                                                                }
                                                                                            />
                                                                                        </td>

                                                                                        {/* <td>{fmt(row.index)}</td> */}
                                                                                        <td>{formatIndex(row.index)}</td>
                                                                                    </tr>
                                                                                ))}

                                                                                <tr className="fw-bold table-secondary">
                                                                                    <td></td>
                                                                                    {/* <td>{fmt(totalWeight)}</td> */}
                                                                                    <td>{formatPercent(totalWeight)}</td>
                                                                                    <td></td>
                                                                                    <td></td>
                                                                                    {/* <td>{fmt(totalIndex)}</td> */}
                                                                                    <td>{formatIndex(totalIndex)}</td>
                                                                                </tr>
                                                                            </tbody>
                                                                        </table>
                                                                        // </div>

                                                                    )}

                                                                    {/* Table 2: Score Grade */}
                                                                    {sheetData.riskMeasurement.gradeHeaders.length > 0 && (

                                                                        // <div className={`tableWrapper ${tableStyles.tableWrapper}`}>
                                                                        <table className={`table table-bordered table-hover text-center customScrollTable ${tableStyles.customScrollTable}`}>
                                                                            <thead className="thead-light">
                                                                                <tr>
                                                                                    {sheetData.riskMeasurement.gradeHeaders.map((h, i) => (
                                                                                        <th key={i}>{h}</th>
                                                                                    ))}
                                                                                </tr>
                                                                            </thead>
                                                                            <tbody>
                                                                                {calculatedGradeRows.map((row, ri) => (
                                                                                    <tr key={ri}>
                                                                                        <td>{row.scoreGrade}</td>
                                                                                        <td>{row.min}</td>
                                                                                        <td>{row.max}</td>

                                                                                        {/* Read from Excel as-is */}
                                                                                        <td>{formatExcelPercent(row.percentage)}</td>

                                                                                        {/* Calculated value */}
                                                                                        <td>{formatApplicablePercent(row.applicablePercentage)}</td>
                                                                                    </tr>
                                                                                ))}
                                                                            </tbody>
                                                                        </table>
                                                                        // </div>

                                                                    )}

                                                                    {/* Table 3: Particulars */}
                                                                    {sheetData.riskMeasurement.particularsRows.length > 0 && (

                                                                        // <div className={`tableWrapper ${tableStyles.tableWrapper}`}>
                                                                        <table className={`table table-bordered table-hover text-center customScrollTable ${tableStyles.customScrollTable}`}>
                                                                            <thead className="thead-light">
                                                                                <tr>
                                                                                    <th>Particulars</th>
                                                                                    <th>Amount</th>
                                                                                </tr>
                                                                            </thead>
                                                                            <tbody>
                                                                                {sheetData.riskMeasurement.particularsRows.map((row, ri) => (
                                                                                    <tr key={ri}>
                                                                                        <td className="text-start">{row.label}</td>

                                                                                        <td>
                                                                                            {ri === 0 ? (
                                                                                                fmt(operationalRiskCharge)
                                                                                            ) : ri === 1 ? (
                                                                                                formatPercentTwoDecimal(totalApplicablePercentage)
                                                                                            ) : (
                                                                                                fmt(capitalChargeForShariahRisk)
                                                                                            )}
                                                                                        </td>
                                                                                    </tr>
                                                                                ))}
                                                                            </tbody>
                                                                        </table>
                                                                        // </div>

                                                                    )}

                                                                    {/* Table 4: Quarterly Capital Charges */}
                                                                    {sheetData.riskMeasurement.quarterHeaders.length > 0 && (
                                                                        
                                                                        <table className="table table-bordered table-hover text-center">
                                                                            <thead>
                                                                                <tr>
                                                                                    {displayedQuarterHeaders.map((h, i) => (
                                                                                        <th key={i}>{h}</th>
                                                                                    ))}
                                                                                </tr>
                                                                            </thead>

                                                                            <tbody>
                                                                                <tr>
                                                                                    {values.map((value, index) => {
                                                                                        const displayValue =
                                                                                            value === "" || value === null || value === undefined
                                                                                                ? 0
                                                                                                : fmt(value);

                                                                                        return (
                                                                                            <td key={index} className="text-end">
                                                                                                {index === 3 ? fmt(q4) : displayValue}
                                                                                            </td>
                                                                                        );
                                                                                    })}
                                                                                </tr>
                                                                            </tbody>
                                                                        </table>
                                                                     
                                                                    )}

                                                                    {/* Final Capital Charge */}
                                                                    {sheetData.riskMeasurement.finalCapital && (
                                                                        <div className="mx-2 mt-3 mb-2">
                                                                            <div className="alert alert-primary d-flex justify-content-between align-items-center mb-0 py-2">
                                                                                <span className="fw-semibold" style={{ fontSize: "0.9rem" }}>
                                                                                    {getFinalCapitalLabel(reportingDate)}
                                                                                </span>
                                                                                <span className="fw-bold fs-6">
                                                                                    {fmt(finalCapitalCharge)}
                                                                                </span>
                                                                            </div>
                                                                        </div>
                                                                    )}

                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>


                                                    {/* </div> */}

                                                    <div className="d-flex justify-content-end gap-2">

                                                        <span
                                                            title={
                                                                !isSubmitEnabled
                                                                    ? "Mandatory fields need to be updated."
                                                                    : ""
                                                            }
                                                        >
                                                            <button
                                                                type="button"
                                                                className="btn btn-primary btn-sm"
                                                                disabled={!isSubmitEnabled}
                                                                onClick={() => {
                                                                    setInputValue("");
                                                                    SetshowMakerremarks(true);
                                                                }}
                                                            >
                                                                Submit
                                                            </button>
                                                        </span>

                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </>
                                )}
                            </div>
                            <Modal show={showConfirmApprove} onHide={() => setShowConfirmApprove(false)} backdrop="static" keyboard={false} style={{ marginTop: '12vh' }}>
                                <Modal.Header
                                    style={{
                                        backgroundColor: '#366872',
                                        color: 'white',
                                        padding: '0.5rem 1rem'
                                    }}
                                    closeButton>
                                    <Modal.Title style={{ fontSize: '16px' }}>Confirm Approval</Modal.Title>
                                </Modal.Header>
                                <Modal.Body style={{ padding: '0.75rem 1rem', fontSize: '14px' }}>
                                    <p>Are you sure you want to Approve this record?</p>
                                </Modal.Body >
                                <Modal.Footer style={{ borderTop: 'none' }}>
                                    <Button variant="secondary"
                                        style={
                                            cancelButtonStyle
                                        } onClick={() => setShowConfirmApprove(false)}>Cancel</Button>
                                    <Button
                                        variant="Primary"
                                        style={submitButtonStyle}
                                        onClick={() => {
                                            setShowConfirmApprove(false);
                                            handleBulkApprove();
                                        }}
                                    >
                                        Submit
                                    </Button>
                                </Modal.Footer>
                            </Modal>

                            <Modal
                                show={showModal}
                                onHide={handleCancel}
                                style={{ marginTop: '12vh' }}
                            >
                                <div className={`alert alert-${messageType === 'success' ? 'success' : 'danger'} fade show`} role="alert"
                                    style={{ marginBottom: '0', maxHeight: '80vh', overflowY: 'auto' }}>

                                    <div className="d-flex align-items-center">
                                        {messageType === 'success' ? (
                                            <span className="me-2" style={{ color: 'green' }}>✅</span>
                                        ) : (
                                            <span className="me-2" style={{ color: 'red' }}>❌</span>
                                        )}
                                        <p
                                            style={{
                                                marginBottom: '0px',
                                                color: messageType === 'success' ? 'green' : 'red',
                                                fontSize: '14px',
                                                whiteSpace: 'pre-wrap' // optional, if you want to preserve spaces or indentation
                                            }}
                                            dangerouslySetInnerHTML={{
                                                __html: modalMessage.replace(/\n/g, '<br />')
                                            }}
                                        ></p>



                                    </div>
                                    <button
                                        type="button"
                                        className="btn-close position-absolute top-0 end-0 m-2" style={{ fontSize: '10px' }}
                                        onClick={handleCancel}>
                                    </button>

                                </div>
                            </Modal>

                            <Modal
                                show={showReportingModal}
                                onHide={() => {
                                    setShowReportingModal(false);
                                    setReportingDate("");
                                    // setAllowSubmit(false);
                                }}
                                backdrop="static"
                                keyboard={false}
                                style={{ marginTop: "12vh" }}
                            >
                                <Modal.Header
                                    style={{
                                        backgroundColor: '#366872',
                                        color: 'white',
                                        padding: '0.5rem 1rem'
                                    }}
                                    closeButton>
                                    <Modal.Title style={{ fontSize: '16px' }}>
                                        Reporting Date Validation
                                    </Modal.Title>
                                </Modal.Header>

                                <Modal.Body style={{ padding: '0.75rem 1rem', fontSize: '14px' }}>
                                    {reportingMessage}
                                </Modal.Body>

                                <Modal.Footer style={{ borderTop: 'none' }}>
                                    <Button
                                        variant="Primary"
                                        style={
                                            submitButtonStyle
                                        }
                                        onClick={() => {
                                            setShowReportingModal(false);
                                            setReportingDate("");
                                            // setAllowSubmit(false);
                                        }}
                                    >
                                        OK
                                    </Button>
                                </Modal.Footer>
                            </Modal>
                            <Modal show={showmakerRemarks} onHide={handleCloseMakerPOP} centered backdrop="static" keyboard={false}>
                                <Modal.Header
                                    style={{
                                        backgroundColor: '#366872',
                                        color: 'white',
                                        padding: '0.5rem 1rem'
                                    }}
                                >
                                    <Modal.Title style={{ fontSize: '16px' }}>Remarks</Modal.Title>
                                </Modal.Header>

                                <Modal.Body className="text-break overflow-auto" style={{ padding: '0.75rem 1rem', fontSize: '14px', maxHeight: "60vh" }}>
                                    <Form.Control
                                        type="text"
                                        placeholder="Enter your remarks"
                                        value={inputValue}
                                        onChange={(e) => setInputValue(e.target.value)}
                                    />
                                </Modal.Body>

                                <Modal.Footer style={{ borderTop: 'none' }}>
                                    <Button variant="btn btn-outline-secondary btn-sm mx-2" style={cancelButtonStyle} onClick={handleCloseMakerPOP}>
                                        Close
                                    </Button>
                                    <Button variant="btn btn-success btn-sm mx-2" onClick={HandleFinalSubmit}>
                                        Submit
                                    </Button>
                                </Modal.Footer>
                            </Modal>

                            {/* </div> */}
                        </div>
                    </div>
                </div>
            </main>
            <Footer />
        </div>
    );
};

export default GapsyResidualModify;